export default __webpack_public_path__ + "static/media/solutions_mob.cbad34bb.jpg";